
let University = Backbone.Model.extend(
    {
        defaults:
            {
                name: null,
                link: null,
                contact_number: null,
                contact_hours: null,
                allow_new_students: false,
                keep_in_cohort: false,
                maximum_course_years: null,
                enrolements_inbox: null,
                hide_unit_codes: false,
                disable_cookies: false,
            },

        getContactNumber: function () {
            return this.get('contact_number')
        },
        getContactHours: function () {
            return this.get('contact_hours')
        },
        allowNewStudents: function () {
            return this.get('allow_new_students')
        },
        keepInCohort: function () {
            return this.get('keep_in_cohort')
        },
        maximumCourseYears: function () {
            return this.get('maximum_course_years')
        },
        enrolementsInbox: function () {
            return this.get('enrolements_inbox')
        },
        hideUnitCodes: function () {
            return this.get('hide_unit_codes')
        },
        disableCookies: function() {
            return this.get('disable_cookies');
        }
    }
);
